import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sequence-detail-workflow-canvas-branches-dash-left",
  "use": "icon-sequence-detail-workflow-canvas-branches-dash-left-usage",
  "viewBox": "0 0 237 54",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 237 54\" fill=\"none\" id=\"icon-sequence-detail-workflow-canvas-branches-dash-left\">\n    <path d=\"M236.508 0.0644531V37.7589C236.508 42.1772 232.926 45.7589 228.508 45.7589H8.50781C4.08953 45.7589 0.507812 49.3406 0.507812 53.7589V89.9916\" stroke=\"#98A1B3\" stroke-dasharray=\"8 4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol